/** Small, embedded avatars travel with the room state; no image hosting is used. */
export const MAX_AVATAR_DATA_URL_LENGTH = 64 * 1024;

export function isValidCreatureAvatar(value: unknown): value is string {
  if (value === '') return true;
  if (typeof value !== 'string' || value.length > MAX_AVATAR_DATA_URL_LENGTH) return false;
  const match = value.match(/^data:image\/(png|jpeg);base64,([A-Za-z0-9+/]+={0,2})$/);
  if (!match || match[2].length % 4 !== 0) return false;
  return match[1] === 'png' ? match[2].startsWith('iVBORw0KGg') : match[2].startsWith('/9j/');
}
